import axios from 'axios'
import { API_BASE } from '../config'

function authHeaders() {
    let token = localStorage.getItem('token');
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

// Bug reports and suggestions, and counting page visits
export default class Feedback {
    // POST /feedback - Send a bug report or suggestion, logged in: kind is 'bug' or 'suggestion', page the address
    // it was sent from. A refusal's response names the field it is about: { field, message }
    send(kind, message, page) {
        return axios.post(`${API_BASE}/feedback`, { kind, message, page }, authHeaders()).then(x => x.data);
    }

    // POST /analytics/visit - A page was opened; visitor is this browser's own random id
    countVisit(path, visitor) {
        return axios.post(`${API_BASE}/analytics/visit`, { path, visitor }, authHeaders()).then(x => x.data);
    }
}
